import type { CourseType } from '../api';

export const getCourseLanguage = (course: CourseType) => {
  if (!course?.title) return undefined;

  if (course.title.endsWith('EN')) {
    return 'en';
  }
  if (course.title.endsWith('DE') || course.title.endsWith('DN')) {
    return 'de';
  }

  return undefined;
};
